import Swal from 'sweetalert2';

export class AlertService {

  confirm = (text: string, confirmButtonSelected: boolean = false) => Swal.fire({
    icon: 'question',
    title: 'Atenção!',
    text: text,
    showDenyButton: true,
    showConfirmButton: true,
    denyButtonText: 'Não',
    confirmButtonText: 'Sim',
    focusConfirm: confirmButtonSelected,
    focusDeny: !confirmButtonSelected
  });

  confirmHtml = (html: string, confirmButtonSelected: boolean = false) => Swal.fire({
    icon: 'question',
    title: 'Atenção!',
    html: html,
    showDenyButton: true,
    showConfirmButton: true,
    denyButtonText: 'Não',
    confirmButtonText: 'Sim',
    focusConfirm: confirmButtonSelected,
    focusDeny: !confirmButtonSelected
  });

  warning = (text: string) => Swal.fire({
    icon: 'warning',
    title: 'Atenção!',
    text: text,
    showConfirmButton: true,
    confirmButtonText: 'Ok'
  });

  warningHtml = (html: string) => Swal.fire({
    icon: 'warning',
    title: 'Atenção!',
    html: html,
    showConfirmButton: true,
    confirmButtonText: 'Ok'
  });

  info = (text: string) => Swal.fire({
    icon: 'info',
    title: 'Importante!',
    text: text,
    showConfirmButton: true,
    confirmButtonText: 'Ok'
  });

  infoHtml = (html: string) => Swal.fire({
    icon: 'info',
    title: 'Importante!',
    html: html,
    showConfirmButton: true,
    confirmButtonText: 'Ok'
  });

  queryInputText = (inputLabel: string, inputValue: string, title: string = 'Atenção!', confirmButtonText?: string) => Swal.fire({
    title,
    input: 'text',
    inputLabel,
    inputValue,
    showCancelButton: true,
    cancelButtonText: 'Cancelar',
    showConfirmButton: confirmButtonText != undefined && confirmButtonText.length > 0,
    confirmButtonText,
    didOpen: () => {
      const modal = document.querySelector('body.swal2-shown .modal');
      if (!modal) return;
      modal.removeAttribute('tabindex');
    }
  });

}